<template>
  <Doughnut
    v-if="isShow"
    v-bind:chart-data="chartData"
    v-bind:chart-options="chartOptions"
    class="doughnut-dashboard"
  />
  <img
    src="@/assets/img/diagram/empty-diagram.svg"
    alt="empty-diagram"
    class="doughnut-dashboard__img"
    v-else>
</template>

<script>
import { Doughnut } from 'vue-chartjs/legacy';

/**
 * @description Генератор цветов
 * @return {Generator<string, void, *>}
 */
function* colorGenerator() {
  const colors = [
    '#0489E0',
    '#ff0000',
    '#D9E1EC',
    '#7371FF',
    '#EC782A',
    '#28b600',
    '#7f00af',
  ];
  let i = 0;
  while (i < colors.length) {
    const color = colors[i];
    yield color;
    i += 1;
    if (i === colors.length) {
      i = 0;
    }
  }
}

/**
 * @description Диаграмма "Бублик"
 */
export default {
  name: 'DoughnutDashboard',
  components: {
    Doughnut,
  },
  computed: {
    /**
     * Показывать ли диаграмму
     *
     * @return {boolean}
     */
    isShow() {
      return this.items
        .filter((item) => item.value > 0)
        .length > 0;
    },
    chartData() {
      return {
        labels: this.items.map((item) => item[this.itemLabelKey]),
        datasets: [
          {
            backgroundColor: this.backgroundColors,
            data: this.items.map((item) => item[this.itemValueKey]),
          },
        ],
      };
    },
    backgroundColors() {
      let i = 0;
      const colors = [];
      const colorVendor = colorGenerator();
      while (i < this.items.length) {
        colors.push(colorVendor.next().value);
        i += 1;
      }
      return colors;
    },
  },
  data() {
    return {
      chartOptions: {
        ...this.options,
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          ...this.plugins,
        },
      },
    };
  },
  props: {
    /**
     * @description Элементы диаграммы
     * @type {Array}
     */
    items: {
      type: Array,
      default: () => [],
    },
    /**
     * @description Ключ метки элемента
     * @type {string}
     */
    itemLabelKey: {
      type: String,
      default: () => 'label',
    },
    /**
     * @description Ключ значения элемента
     * @type {string}
     */
    itemValueKey: {
      type: String,
      default: () => 'value',
    },
    /**
     * @description Опции
     * @type {Object}
     */
    options: {
      type: Object,
      default: () => {},
    },
    /**
     * @description Метки
     * @type {Array}
     */
    labels: {
      type: Array,
      default: () => [''],
    },
    /**
     * @description Плагины
     * @type {Object}
     */
    plugins: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style lang="scss">
.doughnut-dashboard {
  canvas {
    width: 185px;
    height: 185px;
  }
  &__img {
    max-height: 185px;
    max-width: 185px;
  }
}
</style>
